import { getApiUrl } from '../config/api';
import { unsubscribePushNotifications } from '../services/pushNotificationService';

export const clearLocalUserSession = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  Object.keys(localStorage).forEach((key) => {
    if (
      key.startsWith('favorites_') ||
      key.startsWith('notificationCount_') ||
      key.startsWith('wishlistCount_')
    ) {
      localStorage.removeItem(key);
    }
  });
};

export const deleteUserAccount = async () => {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('You are not logged in');
  }

  try {
    await unsubscribePushNotifications();
  } catch {
    // continue even if push unsubscribe fails
  }

  const response = await fetch(getApiUrl('/api/auth/delete-account'), {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });

  const result = await response.json().catch(() => ({}));
  if (!response.ok || !result.success) {
    throw new Error(result.message || 'Failed to delete account');
  }

  clearLocalUserSession();
  return result;
};
